import { render, staticRenderFns } from "./CmgFindAChipotleRestaurantDetails.vue?vue&type=template&id=56b68d7b&scoped=true&lang=pug"
import script from "./cmg-find-a-chipotle-restaurant-details.ts?vue&type=script&lang=ts&external"
export * from "./cmg-find-a-chipotle-restaurant-details.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgFindAChipotleRestaurantDetails.vue?vue&type=style&index=0&id=56b68d7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b68d7b",
  null
  
)

export default component.exports